import api from "../../client";
export interface ApproveProfileResponse {}

export const approveProfile = async (
  profileId: string,
): Promise<ApproveProfileResponse> => {
  const { data } = await api.put<ApproveProfileResponse>(
    `/profile/${profileId}/approve`,
  );
  return data;
};
